import g from "./design-system.es52.js";
import { getElementWidthAndHeight as d } from "./design-system.es140.js";
import { resolveComponent as y, openBlock as c, createBlock as b, withCtx as o, withDirectives as m, createElementVNode as h, normalizeStyle as a, toDisplayString as u, createTextVNode as r, vShow as S, normalizeClass as v, renderSlot as E, createElementBlock as w, createCommentVNode as T, withKeys as f, vModelText as C } from "vue";
/* empty css                    */
/* empty css                    */
import k from "./design-system.es128.js";
const W = {
  name: "DsEditableText",
  components: {
    Editable: g
  },
  props: {
    disabled: Boolean,
    hideIcon: {
      type: Boolean,
      default: !1
    },
    minlength: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: 232
    },
    name: String,
    modelValue: [String, Number],
    iconEdit: Boolean,
    alwaysShowIcon: Boolean,
    placeholder: String,
    nullable: Boolean,
    pattern: String,
    submitted: Boolean
  },
  emits: [
    "cancel",
    "edit",
    "update:modelValue"
  ],
  data() {
    return {
      isEditing: !1,
      text: null,
      previousText: null,
      hideDimensions: !0,
      trailingAndLeadingSpaces: 0,
      invalid: !1,
      fontSize: "",
      fontWeight: "",
      fontFamily: "",
      height: "0px",
      width: "0px"
    };
  },
  computed: {
    hasPlaceholder() {
      return !!(this.placeholder && !this.text);
    },
    computedPattern() {
      let e = this.pattern || ".*";
      return this.minlength > 0 && (e = `.{${this.minlength},}`), e;
    },
    styleObject() {
      return {
        fontSize: this.fontSize,
        fontWeight: this.fontWeight,
        fontFamily: this.fontFamily,
        height: this.height,
        width: this.width
      };
    },
    spaceWidth() {
      const { width: e } = d(this.$refs.pipeSpace), { width: t } = d(this.$refs.pipe);
      return e - 2 * t + 1;
    }
  },
  watch: {
    modelValue(e) {
      this.text = e, this.previousText = e, this.checkInvalid();
    },
    text: {
      handler() {
        this.setDimensions();
      },
      immediate: !0
    },
    submitted() {
      this.checkInvalid();
    }
  },
  created() {
    this.text = this.modelValue, this.previousText = this.modelValue;
  },
  mounted() {
    const { fontSize: e, fontWeight: t, fontFamily: n } = window.getComputedStyle(this.$refs.slotContainer.children[0]);
    this.fontSize = e, this.fontWeight = t, this.fontFamily = n, this.$nextTick(this.setDimensions);
  },
  methods: {
    onChange({ target: e }) {
      e && e.value && (this.text = e.value, this.save());
    },
    handleFocus() {
      this.tryEdit();
    },
    selectText() {
      const e = this.text ? this.text.length : 0;
      this.$nextTick(() => {
        this.$refs.input.setSelectionRange && this.$refs.input.setSelectionRange(0, e);
      });
    },
    cancel() {
      this.$emit("cancel"), this.text = this.previousText, this.isEditing = !1;
    },
    tryEdit() {
      const e = !this.text || this.text.length === 0;
      (!this.iconEdit && !this.disabled || this.iconEdit && this.hasPlaceholder && e) && this.edit();
    },
    edit() {
      this.$emit("edit"), this.openEditable();
    },
    openEditable() {
      this.setDimensions(), this.isEditing = !0, this.$nextTick(() => {
        this.$refs.input.focus(), this.selectText();
      });
    },
    save() {
      (this.text && this.text.trim() !== "" || this.nullable) && (this.previousText = this.text, this.$emit("update:modelValue", this.text)), this.cancel();
    },
    setDimensions() {
      const e = this.$refs.dimensions;
      e && (this.hideDimensions = !1, this.$nextTick(() => {
        const { width: t, height: n } = d(e);
        this.hideDimensions = !0;
        const s = e.textContent.replace(/\S+.+\S/ig, "").length * this.spaceWidth;
        this.height = n === 0 ? "auto" : `${n}px`, this.width = `${t + s + 24}px`;
      }));
    },
    checkInvalid() {
      this.invalid = this.submitted && !this.$refs.input.checkValidity();
    }
  }
}, D = ["name", "placeholder", "maxlength", "pattern"];
function B(e, t, n, p, s, i) {
  const x = y("Editable");
  return c(), b(x, {
    "is-editing": s.isEditing,
    class: "editable",
    disabled: n.disabled,
    "icon-edit": n.iconEdit,
    "always-show-icon": n.alwaysShowIcon,
    "has-placeholder": i.hasPlaceholder,
    "hide-icon": n.hideIcon,
    text: s.text,
    onSave: i.save,
    onCancel: i.cancel,
    onEdit: i.edit,
    onTryEdit: i.tryEdit
  }, {
    dimensions: o(() => [
      m(h("span", {
        style: a(i.styleObject)
      }, [
        h("span", {
          ref: "dimensions",
          class: "dimensions invisible"
        }, u(s.text || n.placeholder), 513),
        t[5] || (t[5] = r()),
        h("span", {
          ref: "pipeSpace",
          style: a(i.styleObject)
        }, "| |", 4),
        t[6] || (t[6] = r()),
        h("span", {
          ref: "pipe",
          style: a(i.styleObject)
        }, "|", 4)
      ], 4), [
        [S, !s.hideDimensions]
      ])
    ]),
    "not-editing": o(() => [
      h("span", {
        ref: "slotContainer",
        tabindex: "0",
        class: v(["not-editing-wrapper", { "icon-edit": n.iconEdit && !i.hasPlaceholder, invalid: s.invalid }]),
        onFocus: t[0] || (t[0] = (...l) => i.handleFocus && i.handleFocus(...l))
      }, [
        E(e.$slots, "default", {}, void 0, !0),
        t[7] || (t[7] = r()),
        i.hasPlaceholder ? (c(), w("span", {
          key: 0,
          class: "placeholder",
          style: a([i.styleObject, { fontWeight: "400" }])
        }, u(n.placeholder), 5)) : T("", !0)
      ], 34)
    ]),
    editing: o(() => [
      m(h("input", {
        ref: "input",
        "onUpdate:modelValue": t[1] || (t[1] = (l) => s.text = l),
        name: n.name,
        type: "text",
        placeholder: s.text || n.placeholder,
        maxlength: n.maxlength,
        pattern: i.computedPattern,
        style: a([i.styleObject, i.hasPlaceholder ? { fontWeight: "400" } : {}]),
        onKeyup: [
          t[2] || (t[2] = f((...l) => i.save && i.save(...l), ["enter"])),
          t[3] || (t[3] = f((...l) => i.cancel && i.cancel(...l), ["esc"]))
        ],
        onChange: t[4] || (t[4] = (...l) => i.onChange && i.onChange(...l))
      }, null, 44, D), [
        [C, s.text]
      ])
    ]),
    _: 3
  }, 8, ["is-editing", "disabled", "icon-edit", "always-show-icon", "has-placeholder", "hide-icon", "text", "onSave", "onCancel", "onEdit", "onTryEdit"]);
}
const j = /* @__PURE__ */ k(W, [["render", B], ["__scopeId", "data-v-2abb9e34"]]);
export {
  j as default
};
//# sourceMappingURL=design-system.es53.js.map
